import { TILES } from "../helpers/tiles";
import ElevatedTile from "../components/object-graphics/TileElevated";
import { BodyPlacement } from "./BodyPlacement";
import { DIRECTION_UP, PLACEMENT_TYPE_CIABATTA } from "../helpers/consts";

export class BulletPlacement extends BodyPlacement {
  constructor(properties, level) {
    super(properties, level);
    this.waitFramesBeforeAIMove = 11;
    this.framesUntilAiMove = this.waitFramesBeforeAIMove;
    this.hasMovedUp = false;
  }

  _handleAIMove() {
    if (!this.hasMovedUp) {
      this._move(DIRECTION_UP);
      this.hasMovedUp = true;
    }
  }

  damagesBodyOnCollide(forBody) {
    return forBody.type === PLACEMENT_TYPE_CIABATTA;
  }

  renderComponent() {
    return <ElevatedTile frameCoord={TILES.BULLET} pxAboveGround={2} />;
  }
}
